import { render } from "./CustomCheckBox.vue?vue&type=template&id=6a308fb4"
import script from "./CustomCheckBox.vue?vue&type=script&lang=js"
export * from "./CustomCheckBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__